module.exports = __webpack_public_path__ + "img/footbanner.f954aeb5.jpg";